/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CoinMember } from './CoinMember';
import {
    CoinMemberFromJSON,
    CoinMemberFromJSONTyped,
    CoinMemberToJSON,
} from './CoinMember';

/**
 * 
 * @export
 * @interface CoinMembersResponse
 */
export interface CoinMembersResponse {
    /**
     * 
     * @type {Array<CoinMember>}
     * @memberof CoinMembersResponse
     */
    data: Array<CoinMember>;
}

/**
 * Check if a given object implements the CoinMembersResponse interface.
 */
export function instanceOfCoinMembersResponse(value: object): value is CoinMembersResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CoinMembersResponseFromJSON(json: any): CoinMembersResponse {
    return CoinMembersResponseFromJSONTyped(json, false);
}

export function CoinMembersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinMembersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CoinMemberFromJSON)),
    };
}

export function CoinMembersResponseToJSON(value?: CoinMembersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(CoinMemberToJSON)),
    };
}

